export default __webpack_public_path__ + "static/media/Bike-biometric.5fe1d613.jpg";